export default "__VITE_ASSET__BNtaQ2YO__"